import {
  PlexMember,
  PlexMemberInput,
  PlexMemberInputType,
  PlexMemberUser,
  SearchUser,
} from '../../../../graphql/gen/types';

export function plexMemberUser(user: SearchUser): PlexMemberUser {
  if (user.plexUserId != null) {
    // TODO(https://github.com/all-hands-hq/source/issues/99)
    return {
      __typename: 'PlexRegisteredUser',
      id: user.plexUserId,
      email: user.email,
      picture: user.picture || '',
      name: user.name || '',
    };
  } else {
    return { __typename: 'PlexInvitedUser', email: user.email };
  }
}

/*
Unique identifier for `user` which could be a registered user or an email address
*/
export function plexUserRoleTargetKey(user: PlexMemberUser): string {
  switch (user.__typename) {
    case 'PlexInvitedUser':
      return `invite-${user.email}`;
    case 'PlexRegisteredUser':
      return `user-${user.id}`;
    default:
      throw new Error(`Invalid PlexUserRoleTarget: ${JSON.stringify(user)}`);
  }
}

export function plexMemberInput(member: PlexMember): PlexMemberInput {
  switch (member.user.__typename) {
    case 'PlexInvitedUser':
      return {
        type: PlexMemberInputType.Email,
        id: member.user.email,
        role: member.role,
      };
    case 'PlexRegisteredUser':
      return {
        type: PlexMemberInputType.PlexUserId,
        id: member.user.id,
        role: member.role,
      };
    default:
      throw new Error(`Invalid member: ${JSON.stringify(member)}`);
  }
}
